import styled from 'styled-components';

export const FieldWithFile = styled.div`
    display: flex;
    min-width: 350px;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    > *:first-child {
        flex: 3;
    }

    > *:last-child {
        flex: 1;
        max-width: 150px;
    }
`;
